import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Topbar from "../components/shared/Topbar";
import Footer from "../components/shared/Footer";
import Footer10ms from "../components/shared/Footer10ms";
import ChatWidget from "../components/chat/ChatWidget";
import AnyChatWidget from "../components/chat/AnyChatWidget";

const apiUrl = import.meta.env.VITE_APP_API;

const Main = () => {
  const [homePageData, setHomePageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHomePageData = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/api/account/organization_home_page`
        );
        setHomePageData(response.data);
      } catch (error) {
        console.error("Error fetching organization data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHomePageData();
  }, []);
console.log(homePageData , "homePageData");

  return (
    <div className="min-h-screen flex flex-col">
      <Topbar homePageData={homePageData} loading={loading} />
      {
        homePageData?.organization?.name === 'nursing' ? <AnyChatWidget /> : <ChatWidget />
          
        
      }
      <main className="flex-grow">
        <Outlet context={{ homePageData, loading }} />
      </main>
      <Footer homePageData={homePageData} loading={loading} />
      {/* <Footer10ms homePageData={homePageData} loading={loading} /> */}
    </div>
  );
};

export default Main;
